module.exports = __webpack_public_path__ + "static/media/moon.0a4770ed.svg";